import React from 'react';
import { Row, Col } from 'react-bootstrap5';

import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import { useContext as useUsersContext } from 'components/Users/Context';

export default function MyStyle() {
  const { state: stateUsers } = useUsersContext();
  const member = stateUsers.user?.attributes?.specific;

  if (!member) {
    return (
      <div className="content">
        <section>
          <LoadingPlaceholder text="Loading..." />
        </section>
      </div>
    );
  }

  return (
    <div className="py-3">
      <div className="my-3 p-3 border">
        <Row className="align-items-center">
          <Col md={6} className="fw-semibold">
            Which of these best describes your job role?
          </Col>

          <Col md={6}>
            {member.career_level}
          </Col>
        </Row>
      </div>

      <div className="my-3 p-3 border">
        <Row className="align-items-center">
          <Col md={6} className="fw-semibold">
            What is your time zone?
          </Col>

          <Col md={6}>
            {member.time_zone}
          </Col>
        </Row>
      </div>

      <div className="my-3 p-3 border">
        <Row className="align-items-center">
          <Col md={6} className="fw-semibold">
            What language would you like to use in your coaching session?
          </Col>

          <Col md={6}>
            {member.prefered_language}
          </Col>
        </Row>
      </div>

      <div className="my-3 p-3 border d-none">
        <Row className="align-items-center">
          <Col md={6} className="fw-semibold">
            I would prefer a coach who is a member of the LGBTQ+ community (if available).
          </Col>

          <Col md={6}>
            {member.lgbt_preference ? 'Yes' : 'No preference'}
          </Col>
        </Row>
      </div>

      <div className="my-3 p-3 border d-none">
        <Row className="align-items-center">
          <Col md={6} className="fw-semibold">
            I would prefer a coach who is, or has been, a working mom.
          </Col>

          <Col md={6}>
            {member.mom_preference ? 'Yes' : 'No preference'}
          </Col>
        </Row>
      </div>
    </div>
  );
}
